import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shared--tabbar"
export default class extends Controller {
  connect() {
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get("tab");

    if (tabParam) {
      const activeTabs = document.querySelectorAll(".active");
      activeTabs.forEach(
        (tab) => (tab.className = tab.className.replace("active", "")),
      );

      const tabLink = document.querySelector(`a[href="#${tabParam}"]`);
      if (tabLink) {
        tabLink.parentElement.className += " active";
        document.getElementById(tabParam).className += " active";
      }
    }
  }

  onClickChangeTab(event) {
    event.preventDefault();
    const activeTabs = document.querySelectorAll(".active");

    activeTabs.forEach(
      (tab) => (tab.className = tab.className.replace("active", "")),
    );

    event.target.parentElement.className += " active";
    const tabId = event.target.href.split("#")[1];
    document.getElementById(tabId).className += " active";

    const url = new URL(window.location);
    url.searchParams.set("tab", tabId);
    window.history.pushState({}, "", url);
  }
}
